{
  "info": {
    "stocks": {
      "tabs": {
        "analytics": "Аналитика",
        "description": "Описание",
        "statistics": "Статистика"
      }
    }
  }
}
